// @ts-check
import { LBButton } from '@linearb/buzz';
import { Flex } from 'components/base/layout-components';
import { useHistory } from 'react-router';

const Footer = ({ isSendInviteDisabled, onSendInvite }) => {
  const { goBack } = useHistory();

  return (
    <Flex justify='end' pt='x-x-large'>
      <Flex gap='1rem'>
        <LBButton variant='outline' onClick={goBack}>
          Cancel
        </LBButton>
        <LBButton disabled={isSendInviteDisabled} onClick={onSendInvite}>
          Send Invitation
        </LBButton>
      </Flex>
    </Flex>
  );
};

export default Footer;
